import i18n from "i18next";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroupModalAttributes } from "src/actions/group";
import SearchHeader from "src/components/SearchHeader.old";
import k from "src/i18n/keys";
import { getCurrentUserId, getGroupsModalShow } from "src/reducers";
import { State } from "src/types";

interface Props {
  text: string;
  handleSearch: (value: string) => void;
}

const Header = ({ text, handleSearch }: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const currentUser = useSelector(({ app }: State) => getCurrentUserId(app));
  const showGroupModal = useSelector(({ app }: State) =>
    getGroupsModalShow(app),
  );

  const openCreateGroup = () => {
    dispatch(
      setGroupModalAttributes({
        title: "",
        show: !showGroupModal,
        members: [currentUser],
        owners: [currentUser],
        locked: false,
        error: null,
        loading: false,
      }),
    );
  };

  return (
    <SearchHeader
      text={text}
      handleChange={handleSearch}
      handleCreate={openCreateGroup}
      button={i18n.t(k.CREATE_GROUP)}
    />
  );
};

export default Header;
